<div class="flex flex-col w-full h-full bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-md p-6 max-h-[calc(100vh-8rem)] overflow-y-auto">
    <h2 class="text-2xl font-bold text-gray-800 mb-6">Fechamento de Turno</h2>
    
    <div class="space-y-4">
      
      <!-- Resumo de Pagamentos por Tipo -->
      <div class="bg-gray-50 p-4 rounded-md">
        <h3 class="text-lg font-semibold text-gray-700 mb-3">Resumo de Pagamentos por Tipo</h3>
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Dinheiro</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="moneyTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">PIX</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="pixTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Cartão de Crédito</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="creditCardTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Cartão de Débito</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="debitCardTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Cheque</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="checkTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Crédito</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="creditTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Transferência Bancária</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="bankTransferTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Vale</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="voucherTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Depósito</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="depositTotal">
          </div>
          
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-600 mb-1">Cashback</label>
            <input 
              type="number" 
              step="0.01"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="0,00"
              [(ngModel)]="cashBackTotal">
          </div>
        </div>
      </div>
    </div>
    
    <div class="flex justify-end space-x-4 mt-6">
      <button 
        (click)="cancel()"
        class="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
        Cancelar (ESC)
      </button>
      <button 
        (click)="closeShift()"
        class="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500">
        Fechar Turno (F1)
      </button>
    </div>
  </div>
</div>